export * from "./artworkspec";
